import { debounce } from 'lodash-es'

import { useMusicOptionsStore } from '../store'

import type { AudioGlobalMetadata } from '@/hooks/audio/store'

import { useAppUIModal } from '@/contexts/AppUIModalContext'
import { useSessionInfo } from '@/contexts/AuthContext/hooks/sessionInfo'


import { api } from '@/utils/api';
import { useCallback } from 'react';
export default function useUpdateLikeStatus(data: AudioGlobalMetadata) {
  const initLikeStatus = {
    isLiked: !!data.isLiked,
    favoriteNum: data.favoriteNum || 0,
  }
  const { signUp } = useAppUIModal()

  const { isSignIn } = useSessionInfo()

  const handleSignIn = () => {
    signUp.show({
      defaultShowSignUp: false,
      triggerLocation: 'home_like_click',
      triggerType: 'home',
    })
  }
  const { mutateAsync: doLike } = api.music_v2.doLike.useMutation()
  const { mutateAsync: doNotLike } = api.music_v2.doNotLike.useMutation()

  const { setLikeStatus, likeMap } = useMusicOptionsStore()
  const likeStatus = likeMap.get(data.id) || initLikeStatus

  const handleClickLike = useCallback(
    debounce(async () => {
      if (!isSignIn) {
        handleSignIn()
        return
      }
      let updateSuccess = true
      if (likeStatus.isLiked) {
        setLikeStatus(data.id, {
          isLiked: false,
          favoriteNum: likeStatus.favoriteNum - 1,
        })
        try {
          await doNotLike({ musicId: data.numId })
        } catch (e) {
          updateSuccess = false
        } finally {
          if (!updateSuccess) {
            setLikeStatus(data.id, initLikeStatus)
          }
        }
      } else {
        setLikeStatus(data.id, {
          isLiked: true,
          favoriteNum: likeStatus.favoriteNum + 1,
        })
        try {
          await doLike({ musicId: data.numId })
        } catch (e) {
          updateSuccess = false
        } finally {
          if (!updateSuccess) {
            setLikeStatus(data.id, initLikeStatus)
          }
        }
      }
    }, 200),
    [likeStatus, isSignIn],
  )

  return {
    likeStatus,
    handleClickLike,
  }
}
